<template>
  <el-dialog
    title="选择商品分类"
    width="600px"
    :visible.sync="dialogVisible"
    @closed="handleClose"
  >
    <el-table
      v-loading="tableLoading"
      :data="categoryList"
      height="300"
      @row-click="handleRowClick"
    >
      <el-table-column label="" width="60px">
        <template slot-scope="{ row }">
          <el-radio :value="selectData.categoryId" :label="row.categoryId">
            <span style="visibility: hidden;">&</span>
          </el-radio>
        </template>
      </el-table-column>
      <el-table-column label="序号" type="index" width="60px" />
      <el-table-column label="分类名称" prop="name" />
    </el-table>
    <div class="page-wrap">
      <el-pagination
        layout="total, prev, pager, next"
        small
        :total="total"
        :current-page.sync="pageInfo.pageNo"
        :page-size="pageInfo.pageSize"
        @current-change="handleCurrentChange"
      />
    </div>
    <template slot="footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleConfirm">确定</el-button>
    </template>
  </el-dialog>
</template>

<script>
import { getYzRetailShopCategories } from '@api/prod/conf/index.js';
import { cloneDeep } from 'lodash';
export default {
  data() {
    return {
      dialogVisible: false,
      selectData: {},
      pageInfo: {
        pageNo: 1,
        pageSize: 20
      },
      categoryList: [],
      userId: null,
      total: 0,
      tableLoading: false,
    }
  },
  methods: {
    handleClose() {
      this.selectData = {};
      this.dialogVisible = false;
      this.categoryList = [];
      this.userId = null;
      this.total = 0;
      this.pageInfo = {
        pageNo: 1,
        pageSize: 20
      };
    },
    handleShow(shopUserId, currentData) {
      this.userId = shopUserId;
      this.selectData = currentData;
      this.dialogVisible = true;
      this.getData();
    },
    handleRowClick(rowData) {
      const { categoryId, name } = rowData;
      if (this.selectData.categoryId === categoryId) {
        return false;
      }
      Object.assign(this.selectData, {
        categoryId, categoryName: name
      });
    },
    handleCurrentChange(val) {
      this.pageInfo.pageNo = val;
      this.getData();
    },
    getData() {
      this.tableLoading = true;
      getYzRetailShopCategories({
        userId: this.userId,
        ...this.pageInfo
      }).then(({ data }) => {
        this.tableLoading = false;
        const { categorys = [], paginator } = data;
        this.categoryList = cloneDeep(categorys);
        this.total = paginator.totalCount;
      }).catch(() => {
        this.tableLoading = false;
        this.categoryList = [];
      })
    },
    handleConfirm() {
      this.$emit('on-confirm', cloneDeep(this.selectData));
      this.handleClose();
    }
  }
}
</script>

<style lang="scss" scoped>
.page-wrap{
  text-align: right;
  margin: 10px 0;
}
</style>